import mockLoginApi from "./login/MockLoginApi";
import LoginApi from "./login/LoginApi";
import UserApi from "./user/UserApi";
import MockReservationApi from "./reservation/MockReservationApi";
import MockUserApi from "./user/MockUserApi";
import ApiService from "./ApiService";
import ReservationApi from "./reservation/ReservationApi";
// import MiscApi from "./misc/MiscApi";
// import MockMiscApi from "./misc/MockMiscApi";
import VehicleApi from "./vehicle/VehicleApi";
import MockVehicleApi from "./vehicle/MockVehicleApi";

class MockApiService implements ApiService {
  dbToken: string;
  jwt: string;
  login: LoginApi;
  reservation: ReservationApi;
  user: UserApi;
  //misc: MiscApi;
  vehicle: VehicleApi;

  constructor(dbToken: string, jwt: string) {
    this.dbToken = dbToken;
    this.jwt = jwt;
    this.login = new mockLoginApi();
    //@ts-ignore
    this.reservation = new MockReservationApi();
    this.user = new MockUserApi();
    //this.misc = new MockMiscApi();
    this.vehicle = new MockVehicleApi();
  }

  setDbToken = (token: string, jwt: string) => {
    this.dbToken = token;
    this.jwt = jwt;
  };
}

export default MockApiService;
